import projects from "../../../utils/projects.json";
import "./DashboardProject.css";

const DashboardProject = () => {
  const compare = (a, b) => {
    if (a.status < b.status) {
      return 1;
    }
    if (a.status > b.status) {
      return -1;
    }
    return 0;
  };
  const sortedProjects = projects.sort(compare);

  return (
    <div className="dashboardProject">
      <table>
        <thead>
          <tr>
            <th>Projects History</th>
            <th>Created At</th>
            <th>Status</th>
            <th>Rank</th>
            <th>Budget</th>
            <th>Team</th>
            <th>Completion</th>
          </tr>
        </thead>
        <tbody>
          {sortedProjects.map((project) => (
            <tr key={project.id}>
              <td className="dashboardProject__ongoing flex-row">
                <img
                  src="https://source.unsplash.com/7YVZYZeITc8"
                  className="rounded"
                  alt=""
                />{" "}
                {project.ongoing_projects}
              </td>
              <td>{new Date().toISOString().substr(0, 10)}</td>
              <td>
                <div className="flex-row">
                  <div
                    className={`dashboardProject__statusCircle rounded ${project.status}`}
                  ></div>
                  {project.status}
                </div>
              </td>
              <td
                className={`dashboardProject__rank ${
                  project.completion === 100
                    ? project.rank <= 10
                      ? "green"
                      : project.rank > 10 && project.rank <= 50
                      ? "yellow"
                      : "red"
                    : ""
                }`}
              >
                {project.completion === 100 ? project.rank : "-"}
              </td>
              <td>
                <strong>${project.budget}</strong>{" "}
              </td>
              <td className="dashboardProject__team flex-row">
                {project.teams.map((team) => (
                  <div className="dashboardProject__teamImg" key={team.id}>
                    <img src={team.img} alt="" />
                    <span>{team.name}</span>
                  </div>
                ))}
              </td>
              <td>
                <div className="dashboardProject__completion flex-row">
                  {project.completion}%
                  <div
                    className={`dashboardProject__completionProgress ${
                      project.completion < 50
                        ? "yellow"
                        : project.completion > 50 && project.completion < 80
                        ? "orange"
                        : project.completion > 80 && project.completion < 100
                        ? "blue"
                        : "green"
                    }`}
                    data-content={`${project.completion}`}
                  ></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardProject;
